import React, { useEffect, useState } from "react";
import { DashboardGeneralSection } from "./DashboardGeneralSection";
import { DashboardBudgetSection } from "./DashboardBudgetSection";
import { DashboardLiquiditySection } from "./DashboardLiquiditySection";
import { DashboardSavingSection } from "./DashboardSavingSection";
import { DashboardGoalSection } from "./DashboardGoalSection";
import { DashboardNotificationSection } from "./DashboardNotificationSection";

import FETCH from "../../utils/fetch";
import DEATH_API from "../../apis/death.api";
import axios from "axios";
import "./mainDashboard.css";
import { Select, Spin } from "antd";
import dashboradReportIcon from "../../assets/images/bank.png";
import editIcon from "../../assets/images/budget/pencil-square.svg";
import { DashboardGoalCharts } from "./DashboardGoalCharts";
import calanderIcon from "../../assets/images/budget/calander.png";
import manageIcon from "../../assets/images/budget/setting-3.svg";
import restIcon from "../../assets/images/budget/restWhite.svg";
import { DatePicker } from "antd";
import { Modal } from "antd";
import moment from "moment";
import { MODULE_API } from "../../apis";
import { BudgetExpanse } from "./BudgetExpanse";
import { TopMonthlyExpanse } from "./TopMonthlyExpanse";
import { GoalProgress } from "./GoalProgress";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CustomSkeleton } from "./CustomSkeleton";
import DashboardCalendar from "../../components/newly-components/DashboardCalendar";
import { NetWorthBudgetGraph } from "../../components/newly-components/NetWorthBudgetGraph";
import ChatComponentDashboard from "../../components/newly-components/ChatComponentDashboard";
import InvestmentWatchlistTable from "../../components/newly-components/MainDashboardAssetTables";
import StoredDocumentsTable from "../../components/newly-components/StoredDocumentsTable";
import PortfolioBalancesTable from "../../components/newly-components/PortfolioBalancesTable";
import UpcomingBillsTable from "../../components/newly-components/UpcomingBillsTable";
import DashboardSavingsGoal from "../../components/newly-components/CircularBarFillComponent";
import { IncomeAndExpensChart } from "../../components/newly-components/IncomeAndExpensChart";
import LatestNews from "../../components/newly-components/LatestNews";
import TasksList from "../../components/newly-components/Tasklist";
import { ArrowRightOutlined } from "@ant-design/icons";
const { Option } = Select;

export const MainDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [assetsAmount, setAssetsAmount] = useState(0);
  const [reportData, setReportData] = useState(null);
  const [editBalance, setEditBalance] = useState(false);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [debtValue, setDebtValue] = useState(0);
  const [availablebalance, setAvailablebalance] = useState(0);
  const [openNotificationContainer, setOpenNotificationContainer] =
    useState(true);

  const [allExpanse, setAllExpanse] = useState([]);
  const [topExpanse, setTopExpanse] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [goals, setGoals] = useState([]);
  const [assetsToselect, setAssetsToSelect] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [selectedUserAssets, setSelectedUserAssets] = useState([]);
  const [originalSetting, setOriginalSetting] = useState([]);
  const [updateTime, setUpdateTime] = useState(null);

  const { MonthPicker } = DatePicker;
  const handleMonthChange = (date, dateString) => {
    if (date) {
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      console.log("Start Date of the Month:", startDate);
      console.log("End Date of the Month:", endDate);
      // resetState();
      callFilter(startDate, endDate);
    }
  };

  const callFilter = async (startDate, endDate) => {
    await getUserRole();
    await getAssetsList();
    // await getMonetaryValue(startDate);
    await getDebt(startDate, endDate);
    await getBudgets(startDate, endDate);
    await getGoals(startDate, endDate);
    await getTopExpanse(startDate, endDate);
    await getExpanse(startDate, endDate);
  };
  const updateUserAssetAvailable = async () => {
    try {
      setLoading(true);
      const filteredAssets =
        assetsToselect &&
        assetsToselect
          .filter((asset) => selectedAssets.includes(asset["Name of Asset"]))
          .map((asset) => {
            return {
              id: asset.id,
              "Name of Asset": asset["Name of Asset"],
            };
          });
      const filteredAssetIds =
        assetsToselect &&
        assetsToselect
          .filter((asset) => selectedAssets.includes(asset["Name of Asset"]))
          .map((asset) => asset.id);

      console.log(
        "filteredAssets",
        filteredAssets,
        filteredAssetIds,
        selectedAssets
      );
      setSelectedUserAssets(filteredAssets);
      const date = new Date();
      setUpdateTime(date);
      let payload = {
        ...originalSetting,
        dragCards: components,
        assets: filteredAssets,
        updatedDate: new Date(),
      };
      let data = await DEATH_API.updateUserAssetSetting(payload);
      if (data && data.status === 200) {
        const date = moment();
        const startDate = date.startOf("month").format("YYYY-MM-DD");
        await getSeletedAssetsMonetaryValue(startDate, filteredAssetIds);
        // await getUserRole();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const updateUserDragCards = async () => {
    try {
      setLoading(true);
      let payload = {
        ...originalSetting,
        dragCards: components,
        assets: selectedUserAssets,
        updatedDate: new Date(),
      };
      let data = await DEATH_API.updateUserAssetSetting(payload);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getUserRole = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getUpdatedRole();
      if (data && data.data && data.data.setting) {
        setOriginalSetting(data.data.setting);
        localStorage.setItem("setting",JSON.stringify(data.data.setting))
        if (data.data.setting.assets) {
          let assets = data.data.setting.assets;
          const assetIds = assets.map((asset) => asset.id);
          setSelectedUserAssets(data.data.setting.assets);
          const date = moment();
          const startDate = date.startOf("month").format("YYYY-MM-DD");
          if (assetIds && assetIds.length > 0) {
            await getSeletedAssetsMonetaryValue(startDate, assetIds);
          }
        }
        if (data.data.setting.updatedDate) {
          setUpdateTime(data.data.setting.updatedDate);
        }
        if (data.data.setting.dragCards) {
          setComponents(data.data.setting.dragCards);
        } else {
          setComponents([
            { id: "budgetExpanse" },
            { id: "dashboardBudgetSection" },
            { id: "dashboardSavingSection" },
            { id: "topMonthlyExpanse" },
            { id: "goalProgress" },
            { id: "dashboardGoalCharts" },
            { id: "dashboardGoalSection" },
            { id: "NetWorthBudgetGraph" },
          ]);
        }
      } else {
        setComponents([
          { id: "budgetExpanse" },
          { id: "dashboardBudgetSection" },
          { id: "dashboardSavingSection" },
          { id: "topMonthlyExpanse" },
          { id: "goalProgress" },
          { id: "dashboardGoalCharts" },
          { id: "dashboardGoalSection" },
          { id: "NetWorthBudgetGraph" },
        ]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getMonetaryValue = async (date) => {
    try {
      setLoading(true);
      setMonetaryValue(0);
      let data = await MODULE_API.getMonetaryValue(date);
      if (data && data.total && data.total[0] && data.total[0].monetary) {
        setMonetaryValue(data.total[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getDebt = async (startDate, endDate) => {
    try {
      setLoading(true);
      setDebtValue(0);
      let data = await MODULE_API.getDebt(startDate, endDate);
      if (data && data.data) {
        setDebtValue(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getSeletedAssetsMonetaryValue = async (date, assetsData) => {
    try {
      setLoading(true);
      setAvailablebalance(0);
      let payload = {
        clientModuleIds: assetsData,
      };
      let data = await MODULE_API.getSelectedMonetaryValue(date, payload);
      if (data && data.total && data.total[0] && data.total[0].monetary) {
        setAvailablebalance(data.total[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleSave = async () => {
    setEditBalance(false);
    await updateUserAssetAvailable();
    setSelectedAssets([]);
  };
  const handleCancel = () => {
    setSelectedAssets([]);
    setEditBalance(false);
  };
  const getBudgets = async (startDate, endDate) => {
    try {
      setLoading(true);
      setBudgets([]);
      let data = await MODULE_API.getFilterBudgets(startDate, endDate);
      if (data && data.data) {
        setBudgets(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getGoals = async (startDate, endDate) => {
    try {
      setLoading(true);
      setGoals([]);
      let data = await MODULE_API.getFilterGoals(startDate, endDate);
      if (data && data.data) {
        setGoals(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getExpanse = async (startDate, endDate) => {
    try {
      setLoading(true);
      setAllExpanse([]);
      let data = await MODULE_API.getTransactionExpanses(startDate, endDate);
      if (data && data.data) {
        setAllExpanse(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getTopExpanse = async (startDate, endDate) => {
    try {
      setLoading(true);
      setTopExpanse([]);
      let data = await MODULE_API.getTopExpanses(startDate, endDate);
      if (data && data.data) {
        setTopExpanse(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const resetState = () => {
    setAllExpanse([]);
    setTopExpanse([]);
    setMonetaryValue(0);
    setBudgets([]);
    setGoals([]);
  };
  useEffect(() => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD");
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    callFilter(startDate, endDate);
  }, []);

  const getAssetsList = async (page = 1, isAppending = false) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: `client-module-service/client-module/list?module=Asset&page=${page}&limit=10`,
        body: {},
      });

      if (datares && datares.records) {
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...datares.records] : datares.records
        );
      }

      // Update hasMore if there are more records to load
      if (datares.pagination) {
        const { limit, total } = datares.pagination;
        setHasMore(page * limit < total); // Check if there are more pages to load
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handlePopupScroll = (e) => {
    const { target } = e;
    if (
      !loading &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      getAssetsList(nextPage, true); // Load next page and append to existing list
    }
  };

  // Handle drag end event to update component order
  const [components, setComponents] = useState([]);

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return; // Dropped outside the list

    const updatedComponents = Array.from(components);
    const [movedComponent] = updatedComponents.splice(source.index, 1);
    updatedComponents.splice(destination.index, 0, movedComponent);

    setComponents(updatedComponents);
  };
  // / Function to render each component dynamically
  const renderComponent = (componentId) => {
    switch (componentId) {
      case "budgetExpanse":
        return (
          <BudgetExpanse
            data={budgets && budgets}
            loading={loading}
            getAllBudgets={getBudgets}
          />
        );
      case "dashboardBudgetSection":
        return (
          <DashboardBudgetSection
            monetary={monetaryValue}
            data={assetsAmount}
            totalLoan={totalLoan}
            debt={debtValue && debtValue}
            totalBalance={totalBalance}
            reportData={reportData}
            loading={loading}
            getNetWorth={getMonetaryValue}
          />
        );
      case "dashboardSavingSection":
        return (
          <DashboardSavingSection
            expenseData={allExpanse && allExpanse}
            loading={loading}
            getAllExpanse={getExpanse}
            getAllTopExpanse={getTopExpanse}
          />
        );
      case "topMonthlyExpanse":
        return (
          <TopMonthlyExpanse
            plaidData={topExpanse && topExpanse}
            loading={loading}
          />
        );
      case "goalProgress":
        return (
          <GoalProgress
            goalsData={goals && goals}
            loading={loading}
            getAllGoals={getGoals}
          />
        );
      case "dashboardGoalCharts":
        return (
          <DashboardGoalCharts goalsData={goals && goals} loading={loading} />
        );
      case "dashboardGoalSection":
        return (
          <DashboardGoalSection goalsData={goals && goals} loading={loading} />
        );
      default:
        return null;
    }
  };

  const assetToselect = [
    {
      id: 25736,
      image:
        "https://assets-planet.s3.amazonaws.com/media/3a42f979-1178-400a-acee-ac6c5d091ca4.png",
      "Name of Asset": "Plaid Saving",
    },
    {
      id: 25727,
      image:
        "https://assets-planet.s3.amazonaws.com/media/f5024e4d-8be7-41b6-9c1f-17194d7cc4bf.png",
      "Name of Asset": "New Asset Auto",
    },
    {
      id: 25726,
      image:
        "https://assets-planet.s3.amazonaws.com/media/36669061-989c-4072-a414-e4394f396b6f.png",
      "Name of Asset": "my airplane",
    },
    {
      id: 25650,
      image:
        "https://assets-planet.s3.amazonaws.com/media/33011756-0bb1-4d7a-8e9b-c35487a27962.png",
      "Name of Asset": "my bike",
    },
    {
      id: 25598,
      image:
        "https://assets-planet.s3.amazonaws.com/media/3a42f979-1178-400a-acee-ac6c5d091ca4.png",
      "Name of Asset": "Remaining from Sale of car",
    },
  ];

  return (
    <>
      {/* <div style={{ padding: "2rem" }}>
        <DashboardCalendar />
      </div>

      <div
        style={{
          padding: "2rem",
          display: "flex",
          alignItems: "stretch",
          gap: "1rem",
          width: "100%",
        }}>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "16px",
          }}>
          <NetWorthBudgetGraph />
        </div>
        <div style={{ width: "100%" }}>
          <ChatComponentDashboard />
        </div>
      </div>
      <div
        style={{
          padding: "2rem",
          display: "flex",
          alignItems: "stretch",
          gap: "1rem",
          width: "100%",
        }}>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "16px",
          }}>
          <InvestmentWatchlistTable />
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "16px",
          }}>
          <StoredDocumentsTable />
        </div>
      </div>
      <div
        style={{
          padding: "2rem",
          display: "flex",
          alignItems: "stretch",
          gap: "1rem",
          width: "100%",
        }}>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "16px",
          }}>
          <PortfolioBalancesTable />
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "16px",
          }}>
          <UpcomingBillsTable />
        </div>
      </div> */}

      {/*  */}
      {/*  */}
      {/*  */}

      <div style={{ display: "flex" }}>
        <Modal visible={editBalance} footer={null} closable={false} centered>
          <h3 className="modaltitle">Edit Available Balance</h3>
          <h3 className="modaltitle" style={{ fontSize: "14px" }}>
            Select Assets to Calculate Available Balance
          </h3>
          <h3 className="inputTitle">All Assets</h3>
          <Select
            mode="multiple"
            showSearch
            style={{ width: "100%" }}
            placeholder="Select Assets"
            onPopupScroll={handlePopupScroll} // Pagination on scroll
            value={selectedAssets && selectedAssets}
            onChange={(value) => {
              console.log("value", value);
              setSelectedAssets(value);
            }}
            notFoundContent={loading ? <Spin /> : null}
            optionLabelProp="label"
          >
            {assetsToselect &&
              assetsToselect.map((asset, index) => (
                <Option
                  key={index}
                  value={asset["Name of Asset"]}
                  label={asset["Name of Asset"]}
                >
                  <span
                    role="img"
                    aria-label={asset["Name of Asset"]}
                    style={{ marginRight: "8px" }}
                  >
                    <img
                      width={32}
                      src={asset.image}
                      alt={asset["Name of Asset"]}
                    ></img>
                  </span>
                  {asset["Name of Asset"]}
                </Option>
              ))}
          </Select>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                handleSave();
              }}
            >
              Save
            </button>
          </div>
        </Modal>

        <div className="MainDashboard1" style={{ padding: "1rem" }}>
          <div
            className="filterWithName"
            style={{
              marginBottom: "1rem",
            }}
          >
            {/*  */}
            {/*  */}
            {/*  */}

            {/*  */}
            {/*  */}
            {/*  */}
            {/* <div className="mainDashbordHeading">Dashboard Overview</div> */}
            {/* <div className="filterWithName">
              <span className="mainfilterHeading">Apply Filter: </span>
              <MonthPicker
                className="monthPickerStyle"
                style={{ width: "250px", border: "1px solid #2a3da3" }}
                onChange={handleMonthChange}
                format="MMMM YYYY"
                placeholder="Select month"
                defaultValue={moment()}
              />
              <div
                className="managedBoard"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => {
                  updateUserDragCards();
                }}>
                <img src={manageIcon} height={26} width={26} alt="icon"></img>
                Save Board
              </div>

              
             
            </div> */}
            {/*  <div className="filterIcons">
      <Select
        suffixIcon={
          <img src={calanderIcon} height={16} width={17} alt="icon"></img>
        }
        showSearch
        style={{ width: 200, outline: "none", border: "none" }}
        placeholder="Select Filter"
        onChange={(value, id) => {
          console.log("value", value);
          // setFilterData(value);
          // handleApplyFilter(value);
        }}
      >
        {tags &&
          tags.map((item, index) => (
            <Option key={index} value={item}>
              {item}
            </Option>
          ))}
      </Select>
    </div> */}
          </div>
          {/*<div className="dashboardSelect">
          <div
            style={{
              width: "47%",
              background: "white",
              color: "black",
              display: "flex",
              alignItems: "center",
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
              paddingLeft: "11px",
            }}
          >
            Client Name:{" "}
            {localStorage.getItem("User") ? (
              localStorage.getItem("User")
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </div>
          
            showSearch
            placeholder="Plan Name"
            style={{ width: "47%" }}
            //   defaultValue={"Frank Jones"}
            listHeight="120"
            // style={{height:"2rem"}}
            // onChange={(value) => {

            // }}
          >
            <Option value="Frank Jones and Tracy Jones">
              Steve and Sally Smith
            </Option>
            <Option value="Frank Jones">Lisa and Anthony May</Option>
            <Option value="Tracy Jone">Bill and Peggy Thompson</Option>
          </Select>
</div> */}
          <div className="generalMain">
            <div
              className="reportCard1"
              style={{ display: "flex", width: "30%" }}
            >
              <div
                className="generalMaincards"
                style={{
                  background: "transparent",
                  width: "100%",
                  color: "white",
                  flexWrap: "nowrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className="generalMaincardsInner"
                    style={{ flexWrap: "nowrap", color: "white" }}
                  >
                    {" "}
                    <div
                      className="generalMainImages"
                      style={{ padding: "10px" }}
                    >
                      <img
                        src={dashboradReportIcon}
                        height={"44px"}
                        alt={"balance"}
                      />{" "}
                    </div>
                    <div className="generalMainHeader">
                      <span className="gerealheading">Available Balance:</span>
                      <span
                        className="gerealheadingValue"
                        style={{ color: "white" }}
                      >
                        ${" "}
                        {availablebalance &&
                          availablebalance
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      src={restIcon}
                      alt="reset"
                    />

                    <img
                      src={editIcon}
                      width={24}
                      alt={"edit"}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setEditBalance(true);
                      }}
                    />
                  </div>
                </div>

                <div
                  className="custom-scrollbar-asset"
                  style={{
                    marginTop: "1rem",
                    overflowY: "auto",
                    height: "3rem",
                  }}
                >
                  {selectedUserAssets &&
                    selectedUserAssets.map((item, index) => (
                      <div key={index}>
                        {item["Name of Asset"] ? item["Name of Asset"] : ""}
                      </div>
                    ))}
                </div>
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "end",
                    color: "rgb(163, 174, 208)",
                  }}
                >
                  <div>
                    {updateTime &&
                      `Updated at: ${
                        updateTime &&
                        moment(updateTime)
                          .local()
                          .format("MM/DD/YYYY [at] hh:mmA")
                      }`}
                  </div>
                </div>
              </div>
            </div>

            <DashboardGeneralSection
              monetary={monetaryValue && monetaryValue}
              debt={debtValue && debtValue}
              data={assetsAmount && assetsAmount}
              totalLoan={totalLoan && totalLoan}
              totalBalance={totalBalance && totalBalance}
              loading={loading}
            />
          </div>

          <div className=""></div>

          {/* <div
            style={{
              marginTop: "16px",
              display: "flex",
              // alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}>
              <div
                style={{
                  width: "100%",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "start",

                  flexDirection: "column",
                }}>
                <div style={{ padding: "1rem 1rem 0 1rem" }}>
                  <h3>Goal Progress Max</h3>
                </div>
                <DashboardSavingsGoal />
              </div>
              <div
                style={{
                  marginRight: "1rem",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  color: "#2A3DA3",
                }}>
                <p style={{ margin: "0", whiteSpace: "nowrap" }}>Show more</p>
                <ArrowRightOutlined />
              </div>
            </div>
          </div>

          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
                padding: "1rem",
              }}>
              <IncomeAndExpensChart />
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
                padding: "1rem",
              }}>
              twitter
            </div>
          </div>

          <div style={{ marginTop: "16px" }}>
            <DashboardCalendar />
          </div>

          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <NetWorthBudgetGraph />
            </div>
            <div style={{ width: "100%" }}>
              <ChatComponentDashboard />
            </div>
          </div>
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <InvestmentWatchlistTable />
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <StoredDocumentsTable />
            </div>
          </div>
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <PortfolioBalancesTable />
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <UpcomingBillsTable />
            </div>
          </div>
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "stretch",
              gap: "1rem",
              width: "100%",
            }}>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <LatestNews />
            </div>
            <div
              style={{
                width: "100%",
                backgroundColor: "white",
                borderRadius: "16px",
              }}>
              <TasksList />
            </div>
          </div> */}

          {components && components.length === 0 ? (
            // Render custom skeleton loader while components are empty
            <CustomSkeleton />
          ) : (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="dashboard" direction="vertical">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {/* Flex layout for the first group */}
                    <div
                      className="budgetMain"
                      style={{ display: "flex", gap: "1rem" }}
                    >
                      {components.slice(0, 2).map((component, index) => (
                        <Draggable
                          key={component.id}
                          draggableId={component.id}
                          index={index}
                        >
                          {(provided, snapshot) => {
                            const isDragging = snapshot.isDragging;

                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  width: "50%", // Explicitly set width to 50%
                                  background: "white",
                                  borderRadius: "16px",
                                  padding: "1rem",
                                  ...(isDragging && {
                                    width:
                                      provided.draggableProps.style.width ||
                                      "50%", // Maintain the 50% width while dragging
                                  }),
                                }}
                              >
                                {renderComponent(component.id)}
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                    </div>

                    {/* Flex layout for the second group */}
                    <div
                      className="SavingMain"
                      style={{ display: "flex", gap: "1rem" }}
                    >
                      {components.slice(2, 4).map((component, index) => (
                        <Draggable
                          key={component.id}
                          draggableId={component.id}
                          index={index + 2}
                        >
                          {(provided, snapshot) => {
                            const isDragging = snapshot.isDragging;

                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  width: "50%", // Explicitly set width to 50%
                                  background: "white",
                                  borderRadius: "16px",
                                  padding: "1rem",
                                  ...(isDragging && {
                                    width:
                                      provided.draggableProps.style.width ||
                                      "50%", // Maintain the 50% width while dragging
                                  }),
                                }}
                              >
                                {renderComponent(component.id)}
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                    </div>

                    {/* Flex layout for the third group */}
                    <div
                      className="GoalsMain"
                      style={{ display: "flex", gap: "1rem" }}
                    >
                      {components.slice(4, 6).map((component, index) => (
                        <Draggable
                          key={component.id}
                          draggableId={component.id}
                          index={index + 4}
                        >
                          {(provided, snapshot) => {
                            const isDragging = snapshot.isDragging;

                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  width: "50%", // Explicitly set width to 50%
                                  background: "white",
                                  borderRadius: "16px",
                                  padding: "1rem",
                                  ...(isDragging && {
                                    width:
                                      provided.draggableProps.style.width ||
                                      "50%", // Maintain the 50% width while dragging
                                  }),
                                }}
                              >
                                {renderComponent(component.id)}
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                    </div>

                    {/* Single component without flex */}
                    <div className="GoalsMain">
                      {components.slice(6).map((component, index) => (
                        <Draggable
                          key={component.id}
                          draggableId={component.id}
                          index={index + 6}
                        >
                          {(provided, snapshot) => {
                            const isDragging = snapshot.isDragging;
                            const isDashboardGoalSection =
                              component.id === "dashboardGoalSection";

                            return (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  width: isDashboardGoalSection
                                    ? "100%"
                                    : "50%", // Full width for dashboardGoalSection
                                  background: "white",
                                  borderRadius: "16px",
                                  padding: "1rem",
                                  ...(isDragging && {
                                    width:
                                      provided.draggableProps.style.width ||
                                      "100%", // Maintain full width while dragging
                                  }),
                                }}
                              >
                                {renderComponent(component.id)}
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                    </div>

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}

          {/* <div className="budgetMain" style={{ gap: "1rem" }}>
          <BudgetExpanse
            monetary={monetaryValue && monetaryValue}
            data={assetsAmount && assetsAmount}
            totalLoan={totalLoan && totalLoan}
            totalBalance={totalBalance && totalBalance}
            reportData={reportData && reportData}
            loading={loading}
          />
          <DashboardBudgetSection
            monetary={monetaryValue && monetaryValue}
            data={assetsAmount && assetsAmount}
            totalLoan={totalLoan && totalLoan}
            totalBalance={totalBalance && totalBalance}
            reportData={reportData && reportData}
            loading={loading}
          />
        </div>
        <div
          className="SavingMain"
          style={{
            display: "flex",
            gap: "1rem",
            width: "100%",
          }}
        >
          <DashboardSavingSection
            plaidData={topExpanse && topExpanse}
            loading={loading}
          />
          <TopMonthlyExpanse
            plaidData={topExpanse && topExpanse}
            loading={loading}
          />
        </div>
        <div
          className="GoalsMain"
          style={{
            display: "flex",
            gap: "1rem",
            width: "100%",
          }}
        >
          <GoalProgress />
          <DashboardGoalCharts />
        </div>*/}
          {/* <div className="GoalsMain">
          <DashboardGoalSection />
        </div> */}
        </div>
      </div>
    </>
  );
};
